<template>
    <div :id="idDelInput">
        <div>
            <h5><i class="fas fa-file-alt"></i>&nbsp;Información de cédula [#Folio: {{cedula.CedulaId}}]</h5>
            <hr style="height:2px;border:none;color:#FFF;background-color:#FFF;"/>
            <div class="form-group">
                <div class="form-group">
                    <h6 for="texto_dieccion_area">Juzgado</h6>
                    <input disabled="disabled" v-model="juzgado" type="text" id="texto_dieccion_area" class="form-control"/>
                </div>
                <div id="informacion-expediente-dbdc" class="d-flex justify-content-between">
                    <div class="form-group" style="width: 49%">
                        <h6 for="texto_tipo_documento">Tipo de documento</h6>
                        <input disabled="disabled" v-model="tipoDocumento" type="text" id="texto_tipo_documento" class="form-control"/>
                    </div>
                    <div class="form-group" style="width: 49%">
                        <h6 for="texto_numero_expediente">Consecutivo</h6>
                        <input disabled="disabled" v-model="numeroDeExpediente" type="text" id="texto_numero_expediente" class="form-control"/>
                    </div>                                                          
                </div>                                
                <div id="informacion-urgencia-dbdc" class="d-flex justify-content-between">
                    <div class="form-group" style="width: 49%">
                        <h6 for="tipo_cedula">Tipo de cédula</h6>
                        <input disabled="disabled" v-model="cedula.TipoCedula.Nombre" type="text" id="tipo_cedula" class="form-control"/>
                    </div>                    
                    <div class="form-group" style="width: 49%">
                        <h6 for="texto_fecha_creacion">Fecha de creación</h6>
                        <input  disabled="disabled" v-model="fechaCreacion" type="text" id="texto_fecha_creacion" class="form-control"/>
                    </div>
                </div>
                <div v-if="!conSalidasYConstituciones" class="form-group">
                    <h6 for="texto_usr_registro">Usuario que registró cédula</h6>
                    <input disabled="disabled" v-model="NOMBRE_COMPLETO_USUARIO" type="text" id="texto_usr_registro" class="form-control"/>
                </div>                
                <div  id="informacion-salidas-dbdc" class="row">
                    <div class="form-group col-3">
                        <h6 for="texto_urgente">Urgente</h6>
                        <input disabled="disabled" v-model="cedulaUrgenteTexto" type="text" id="texto_urgente" class="form-control text-center"/>
                    </div>
                    <div class="form-group col-4">
                        <h6 for="texto_acuerdos">No. de Acuerdos</h6>
                        <input  disabled="disabled" v-model="numeroAcuerdos" type="text" id="texto_acuerdos" class="form-control"/>
                    </div>
                    <div v-if="conSalidasYConstituciones" class="form-group col-3" style="width: 24%">
                        <h6 for="texto_nSalidas">Salidas</h6>
                        <input disabled="disabled" v-model="cedula.Salidas.length" type="text" id="texto_nSalidas" class="form-control text-center"/>
                    </div>
                    <div v-if="conSalidasYConstituciones" class="form-group col-3" style="width: 24%">
                        <h6 for="texto_nConstituciones">Constituciones</h6>
                        <input  disabled="disabled" v-model="cedula.Salidas.filter(s => s.Constituciones != null).length" type="text" id="texto_nConstituciones" class="form-control text-center"/>
                    </div>
                </div>
                <div v-if="conVisualizadorDeDocumento" class="form-group">
                    <h6 :for="'input-archivo'">Archivo de cédula</h6>
                    <div class="contenedor-plantilla" :id="'input-archivo'">
                        <div class="d-flex justify-content-between align-items-center">
                            <div class="d-flex justify-content-between align-items-center">
                                <i class="fas fa-file-alt mr-2" style="font-size: 23px;"></i>
                                <span style="color: #000000; font-weight: bold;">{{ nombreArchivoDeCedula }}</span>
                            </div>
                            <div v-if="cedula.ArchivoRuta != null">
                                <button @click="evtVisualizarArchivo($event)" type="button" class="btn-sm btn-primary"><i class="fas fa-eye"></i>&nbsp;&nbsp;Ver archivo</button>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div class="modal align-middle visor-documento" tabindex="-1" data-backdrop="static" data-keyboard="false"  :id="'visor-documento-' + idDelInput">
            <div class="modal-dialog modal-lg modal-dialog-centered">
                <div class="modal-content">
                    <div class="modal-header">
                        <h5 class="modal-title">Archivo de cédula [#Folio: {{cedula.CedulaId}}]</h5>
                        <button :id="'btn-cerrar-visor-documento-' + idDelInput" class="close" data-dismiss="modal"><i class="fas fa-times-circle"></i></button>
                    </div>
                    <div class="modal-body">
                        <div v-if="cedula.ArchivoRuta != null">
                            <div>
                                <PDFDocument :url="cedula.ArchivoRuta" :height="'600px'"/>
                            </div>
                        </div>  
                    </div>  
                </div>
            </div>
        </div>
    </div>
</template>
<script>
import PDFDocument from '@/../src/components/Comunes/PDFDocument'

export default {
    props: {      
      idDelInput: String,
      cedula: Object,
      conVisualizadorDeDocumento: {
          default: false,
          type: Boolean
      },
      conSalidasYConstituciones: {
          default: false,
          type: Boolean
      }
    },
    components: {
        PDFDocument
    },
    data() {
        return {
            FORMATO_FECHA: "DD/MM/YYYY HH:mm:ss",
            numeroDeExpediente: null,
            tipoDocumento: null,
            NOMBRE_COMPLETO_USUARIO: null,
            nombreArchivoDeCedula: 'La cédula no cuenta con un archivo.',
            cedulaUrgenteTexto: null,
            fechaCreacion: null,
            numeroAcuerdos: 0,
            juzgado: null
        }
    },
    methods: {
        evtVisualizarArchivo: function() {
            $('#visor-documento-' + this.idDelInput).modal('show');
        },
        obtenerNombreCompleto: function() {
            const USUARIO = this.cedula.UsuarioQueRegistro;
            const DATOS_NOMBRE = [USUARIO.Nombre, USUARIO.ApellidoPaterno, USUARIO.ApellidoMaterno];
            return DATOS_NOMBRE.join(' ');
        },
        obtenerNombreArchivoDeCedula: function() {
            if(this.cedula.ArchivoRuta != null && this.cedula.ArchivoRuta != "") {
                const RUTA_ARCHIVO = this.cedula.ArchivoRuta.split('\\');
                const NOMBRE_ARCHIVO = RUTA_ARCHIVO[RUTA_ARCHIVO.length -1];
                this.nombreArchivoDeCedula =` ${NOMBRE_ARCHIVO}`;
            }
        }
    },
    created() {
        this.NOMBRE_COMPLETO_USUARIO = this.obtenerNombreCompleto();
        this.obtenerNombreArchivoDeCedula();
        this.cedulaUrgenteTexto = (this.cedula.Urgente) ? 'SI' : 'NO';
        this.fechaCreacion = moment(this.cedula.FechaDeRegistro).format(this.FORMATO_FECHA);
        this.juzgado = 'Sin juzgado';
        if(this.cedula.Expediente != null) {
            this.juzgado = this.cedula.Expediente.Juzgado.Nombre;
            this.tipoDocumento = (this.cedula.Expediente.TipoDocumento != null) ? this.cedula.Expediente.TipoDocumento.Nombre : null;
            this.numeroDeExpediente = this.cedula.Expediente.NumeroDeDocumento;
            this.numeroAcuerdos = (this.cedula.Expediente.Acuerdos != null) ? this.cedula.Expediente.Acuerdos.length : 0;
        }
    }
}
</script>
<style scoped>
@media screen and (max-width: 1039px) {
  #informacion-expediente-dbdc {
    flex-direction: column !important;
  }

  #informacion-expediente-dbdc div{
    width: 100% !important;
  }

  #informacion-urgencia-dbdc {
    flex-direction: column !important;
  }

  #informacion-urgencia-dbdc div{
    width: 100% !important;
  }

  #informacion-salidas-dbdc {
    flex-direction: column !important;
  }

  #informacion-salidas-dbdc div{
    width: 100% !important;
  }
}
.contenedor-plantilla {
    padding: 5px 9px 5px 9px;
    border-radius: 4px;
    background-color: #817c7c;
}

.visor-documento .modal-lg {
    max-width: 70% !important;
}

.modal-header {
    background-color: rgb(36, 34, 34);;
    border: none;
}

.btn-sm {
    cursor: pointer;
}

.btn-sm:hover, .btn-sm:focus {
    background-color: black;
}
</style>


// WEBPACK FOOTER //
// src/components/SINOJ/Comun/CDescripcionBasicaDeCedula.vue